import { render, staticRenderFns } from "./footer-newsletter.vue?vue&type=template&id=4e1a4b2d&scoped=true&"
import script from "./footer-newsletter.vue?vue&type=script&lang=js&"
export * from "./footer-newsletter.vue?vue&type=script&lang=js&"
import style0 from "./footer-newsletter.vue?vue&type=style&index=0&id=4e1a4b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a4b2d",
  null
  
)

export default component.exports